// import { browserName, fullBrowserVersion, osName, osVersion } from "react-device-detect";
import packageInfo from "../../package.json";
// const widthScreen = window.innerWidth;
// const height = window.innerHeight;

const WebVersion = () => {
    return (
        <div className="text-white fixed bottom-0 right-1 z-50 ">
            {/* <div className=" right-0  text-xs font-mono text-white h-5 w-5 rounded-full flex items-center justify-center bg-gray-700 sm:bg-pink-500 md:bg-purple-500 lg:bg-green-500 xl:bg-blue-500">
				<div className="block sm:hidden md:hidden lg:hidden xl:hidden">al</div>
				<div className="hidden sm:block md:hidden lg:hidden xl:hidden">sm</div>
				<div className="hidden sm:hidden md:block lg:hidden xl:hidden">md</div>
				<div className="hidden sm:hidden md:hidden lg:block xl:hidden">lg</div>
				<div className="hidden sm:hidden md:hidden lg:hidden xl:block 2xl:hidden">xl</div>
				<div className="hidden sm:hidden md:hidden lg:hidden xl:hidden 2xl:block">2xl</div>
			</div>
			<div className="text-xs font-bold">
				{widthScreen} x {height}
			</div>
			<p className="text-xs">{browserName}</p>
			<p className="text-xs">{fullBrowserVersion}</p>
			<p className="text-xs">
				{osName}-{osVersion}
			</p> */}
            <p className="text-xs font-bold text-black">V{packageInfo.version}</p>
        </div>
    );
};

export default WebVersion;
